import { render, staticRenderFns } from "./billDes.vue?vue&type=template&id=6a89125e&scoped=true"
import script from "./billDes.vue?vue&type=script&lang=js"
export * from "./billDes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a89125e",
  null
  
)

export default component.exports